export function exampleSlider() {

    $(function () {
        var owl = $('.owl-example');
        owl.owlCarousel({
            items: 1,
            margin: 32,
            stagePadding: 0,
            loop: true,
            autoplay: true,
            autoplaySpeed: 1500,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            dragEndSpeed: 800,
            nav: false,
            center: true,
            dots: true,
            mouseDrag: true,
            touchDrag: true,
            responsive: {
                768: {
                    center: false,
                    items: 2,
                },
                1024: {
                    center: false,
                    items: 3,
                },
                1366: {
                    center: false,
                    items: 4
                }

            },
        });

    });

    return 'exampleSlider';

}